import { withNamespaces } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { toast } from "react-toastify";

import OtherAssetsService from "src/modules/data-protection/apis/OtherAssetsService";

import React, { useEffect, useState } from "react";


import FirstRow from "./FirstRow";
import SecondRow from "./SecondRow";
import CommonService from "src/modules/data-protection/apis/CommonService";
import ResponsiblePerson from "./responsiblePerson";

const InfoCards = ({
    t,
    assetId,
    secondaryId,
    handleFetchSoftwareDetailsQuery,
    // Analysts
    setSelectedAssignedAnalyst,
    selectedAssignedAnalyst,
    // Statuses
    selectedStatus,
    setSelectedStatus,
    statuses,
    // Priorities
    priorities,
    selectedPriority,
    setSelectedPriority,
    // Providers,
    selectedProvider,
    setSelectedProvider,
    // Types
    setSelectedAssetType,
    selectedAssetType,
    // OS
    selectedOperatingSystem,
    setSelectedOperatingSystem,
    // Version
    version,
    // Service
    service,
    // Modules
    selectedModules,
    // Attachments
    attachments,
    // Company
    selectedCompany,
    // Position
    selectedPosition,
    // Phone Number
    selectedPhoneNumber,
    // Email
    selectedEmail,
    // Department
    selectedDepartment,
    // Responsible Person
    selectedResponsiblePerson,
    // Entities
    changeSelectedEntity,
    selectedLegalEntities,
    legalEntitiesOptions,
    fetchLegalEntitiesOptions,

    notice,
    setNotice,

    countries,
    selectedHostingLocation,
    setSelectedHostingLocation,
    selectedNoneEUHostingLocation,
    setSelectedNoneEUHostingLocation,

    overviewHeaderRef
}) => {
    const [asset, setAsset] = useState(null);

    const handleFetchAssetBasicInformation = useQuery({
        queryKey: ["data-protection-other-assets-overview-content", assetId],
        queryFn: async () => {
            const service = OtherAssetsService.getInstance();
            return await service.details(assetId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            toast(t("An error occurred while fetching overview content."), {
                type: "error",
            });
        },
    });

    const {
        data: users
    } = useQuery({
        queryKey: ['gdpr-fetch-analysts-and-admins-list'],
        queryFn: async () => {
            const service = CommonService.getInstance();

            const result = await service.analystAdminsAndAnalysts();

            return (result || []).map((u) => {
                return {
                    value: u.id,
                    label: `${u.first_name} ${u.last_name}`,
                };
            })
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching users."), {
                type: "error",
            });
        }
    });

    const {
        data: responsiblePeopleList
    } = useQuery({
        queryKey: ['gdpr-fetch-tasks-owners-list'],
        queryFn: async () => {
            const service = CommonService.getInstance();

            const result = await service.fetchTaskOwners();

            return (result || []).map((u) => {
                return {
                    value: u.id,
                    label: `${u.first_name} ${u.last_name}`,
                };
            })
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching users."), {
                type: "error",
            });
        },
    });

    useEffect(() => {
        if (handleFetchAssetBasicInformation.data) {
            setAsset(handleFetchAssetBasicInformation.data);
        }
    }, [handleFetchAssetBasicInformation.data]);

    return (
        <React.Fragment>
            <FirstRow
                // General
                handleFetchSoftwareDetailsQuery={handleFetchSoftwareDetailsQuery}
                assetId={assetId}
                secondaryId={secondaryId}
                // Analysts
                setSelectedAssignedAnalyst={setSelectedAssignedAnalyst}
                selectedAssignedAnalyst={selectedAssignedAnalyst}
                users={users}
                // Statuses
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                statuses={statuses}
                // Priorities
                selectedPriority={selectedPriority}
                setSelectedPriority={setSelectedPriority}
                priorities={priorities}
                // Entities
                changeSelectedEntity={changeSelectedEntity}
                selectedLegalEntities={selectedLegalEntities}
                legalEntitiesOptions={legalEntitiesOptions}
                fetchLegalEntitiesOptions={fetchLegalEntitiesOptions}
                overviewHeaderRef={overviewHeaderRef}
            />

            <SecondRow
                // General
                assetId={assetId}
                handleFetchSoftwareDetailsQuery={handleFetchSoftwareDetailsQuery}
                // Providers
                selectedProvider={selectedProvider}
                setSelectedProvider={setSelectedProvider}
                // Asset Type
                selectedAssetType={selectedAssetType}
                setSelectedAssetType={setSelectedAssetType}
                // OS
                selectedOperatingSystem={selectedOperatingSystem}
                setSelectedOperatingSystem={setSelectedOperatingSystem}
                // Version
                version={version}
                // Service
                service={service}
                // Selected Modules
                selectedModules={selectedModules}
                // Responsible Person
                users={responsiblePeopleList}
                // Attachments
                attachments={attachments}
                // Company
                selectedCompany={selectedCompany}
                // Position
                selectedPosition={selectedPosition}
                // Phone Number
                selectedPhoneNumber={selectedPhoneNumber}
                // Email
                selectedEmail={selectedEmail}
                // Department
                selectedDepartment={selectedDepartment}
                // Responsible Person
                selectedResponsiblePerson={selectedResponsiblePerson}
                notice={notice}
                setNotice={setNotice}
                

                countries={countries}
                selectedHostingLocation={selectedHostingLocation}
                setSelectedHostingLocation={setSelectedHostingLocation}
                selectedNoneEUHostingLocation={selectedNoneEUHostingLocation}
                setSelectedNoneEUHostingLocation={setSelectedNoneEUHostingLocation}

                overviewHeaderRef={overviewHeaderRef}
            />

            <ResponsiblePerson
                assetId={assetId}
                handleFetchSoftwareDetailsQuery={handleFetchSoftwareDetailsQuery}
                users={responsiblePeopleList}
                selectedCompany={selectedCompany}
                selectedPosition={selectedPosition}
                selectedPhoneNumber={selectedPhoneNumber}
                selectedEmail={selectedEmail}
                selectedDepartment={selectedDepartment}
                selectedResponsiblePerson={selectedResponsiblePerson}
            />
        </React.Fragment>
    );
};

export default withNamespaces()(InfoCards);
